module.exports = __webpack_public_path__ + "b87c7ce10416fe3fa6eb349c43d7dd81.MP3";